<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>
            {{
              dataRequest.id && activeWarranty == false
                ? 'Sửa phiếu'
                : activeWarranty
                  ? 'Ghi nhận hoạt động'
                  : 'Tạo phiếu'
            }}
            bảo hành
          </h1>
          <div style="float: right">
            <button type="button" @click="$router.push('/warranty')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <div class="form-group row" v-if="dataRequest.id">
                <label class="col-sm-3 col-form-label">Kho</label>
                <div class="col-sm-9">
                  {{ dataRequest.initInventoryName }}
                </div>
              </div>
              <ValidationProvider
                rules="required"
                vid="inventoryId"
                name="Kho"
                v-if="!dataRequest.id"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Kho<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      @change="
                        (dataRequest.inventoryId = inventoryId), fetchDeviceActive(inventoryId)
                      "
                      :disabled="!!dataRequest.id"
                      v-model="inventoryId"
                      :options="warehouseUserActiveData"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="type" name="Tình trạng bảo hành">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Tình trạng bảo hành<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      ref="dataRequestType"
                      v-model="typeWarranty"
                      @change="checkChange(typeWarranty)"
                      :options="Config.warrantyStatus"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required"
                vid="merchantId"
                name="Merchant"
                v-if="!dataRequest.id"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Merchant<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <input
                      type="hidden"
                      class="form-control text-left"
                      v-model="merchantSelected"
                    />
                    <input
                      type="text"
                      class="form-control text-left"
                      :disabled="!!dataRequest.id && dataRequest.status != 'NEW'"
                      :value="
                        merchantSelected.merchantName ? `${merchantSelected.merchantName}` : ''
                      "
                      placeholder="Chọn merchant"
                      v-b-modal.select-merchant-dialog
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_6" vid="description" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Ghi chú</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div class="form-group row" v-if="dataRequest.id">
                <label class="col-sm-3 col-form-label">Người tạo</label>
                <div class="col-sm-9">
                  {{ dataRequest.creator.name }}
                </div>
              </div>
              <div class="form-group row" v-if="dataRequest.id">
                <label class="col-sm-3 col-form-label">Ngày tạo</label>
                <div class="col-sm-9">
                  {{ dataRequest.createTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div v-if="dataRequest.inventoryId && dataRequest.type">
        <div class="addDevice mb-2 ml-2">
          <h6>Danh sách thiết bị</h6>
          <div>
            <button
              @click="showModalRequestDevice()"
              v-if="listDeviceError.length < 1"
              class="btn btn-success btn-primary ml-3 mr-4"
            >
              Thêm thiết bị
            </button>
          </div>
        </div>
        <div class="row tableDevice">
          <div class="table-responsive text-center">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col"><b>Serial</b></th>
                  <th scope="col"><b>Loại thiết bị</b></th>
                  <th scope="col"><b>Các lỗi</b></th>
                  <th scope="col"><b>Đối tượng gây lỗi</b></th>
                  <th scope="col"><b>Ghi chú</b></th>
                  <th scope="col"><b>Tình trạng đề xuất</b></th>
                  <th scope="col"><b>Ảnh và file đính kèm</b></th>
                  <th scope="col"><b>Hành động</b></th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="(item, index) in listDeviceError" :key="index">
                  <td class="text-center">{{ item.serial }}</td>
                  <td class="text-center">
                    <span> {{ item.name }}</span>
                  </td>
                  <td class="text-center">
                    <span>{{ item.errors.join(', ') }}</span>
                  </td>
                  <td class="text-center">{{ item.reason | transformData(Config.faultMaker) }}</td>
                  <td class="text-center">{{ item.note }}</td>
                  <td class="text-center">
                    <span v-if="typeWarranty === 'SUCCESS'">Hoạt động</span>
                    <span v-else-if="dataRequest.type === 'SUCCESS'">Hoạt động</span>
                    <span v-else> {{ item.typeError | transformData(Config.stateDevices) }}</span>
                  </td>
                  <td class="text-center">
                    <UploadMultiple
                      :lsData="item.imgErrors"
                      uniqueKey="images"
                      :canUpload="false"
                      titleClass="form-inner-heading"
                    />
                    <!-- {{  item.imgErrors }} -->
                  </td>
                  <td class="text-center">
                    <b-dropdown class="text-center" variant="outline-light">
                      <b-dropdown-item class="dropdown-item" @click="editDevice(item)"
                        ><span>&nbsp;</span>Sửa
                      </b-dropdown-item>
                      <b-dropdown-item
                        class="dropdown-item"
                        v-if="!dataRequest.id"
                        @click="deleteDevice(index)"
                        ><span>&nbsp;</span>Xóa
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <modalRequestDevice
      v-if="isShowModalRequestDevice"
      :closeModalRequestDevice="closeModalRequestDevice"
      :typeWarranty="typeWarranty"
      :dataSerial="listDevice"
      :lsData="dataDevice"
      @updateDevice="updateDevice"
    />
    <SelectMerchant @selectMerchant="onSelectMerchant" />
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import modalRequestDevice from './modalRequestDevice.vue'
  import omit from 'lodash/omit'
  import pick from 'lodash/pick'
  import SelectMerchant from '@/components/SelectMerchant.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    name: 'warranty-request',
    data() {
      return {
        Config,
        dataRequest: {},
        dataProduct: [],
        showLoading: false,
        warehouseUserActiveData: [],
        listDevice: [],
        listDeviceError: [],
        deviceErrorReq: {},
        dataDevice: {},
        isShowModalRequestDevice: false,
        typeWarranty: '',
        inventoryId: '',
        activeWarranty: false,
        merchantSelected: {},
      }
    },
    components: { modalRequestDevice, SelectMerchant, UploadMultiple },
    created() {
      if (this.$route.params.id) {
        if (this.$route.fullPath.split('/')[2] === 'active') this.activeWarranty = true
        this.fetchData()
      } else this.fetchWarehouse()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
    },
    methods: {
      async submitRequest() {
        if (this.listDeviceError.length === 0) {
          this.showFailMx('Vui lòng thêm thiết bị')
          return
        }
        try {
          this.showLoading = true
          const params = this.preareDataAddWarranty()
          if (this.dataRequest.id) {
            params.id = this.dataRequest.id
            const body = this.convertedData(params)
            const response =
              this.activeWarranty === true
                ? await DeviceService.activeWarranty(body)
                : await DeviceService.updateWarranty(body)
            if (response.success) {
              this.showSuccessMx(
                this.activeWarranty
                  ? 'Ghi nhận hoạt động bảo hành thành công'
                  : 'Cập nhật phiếu bảo hành thành công'
              ).then(() => this.$router.push('/warranty'))
            } else this.showFailMx(response.message)
          } else {
            const response = await DeviceService.createWarranty(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới phiếu bảo hành').then(() =>
                this.$router.push('/warranty')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      convertedData(dataConvert) {
        const deviceErrorReq = pick(dataConvert.deviceErrorReq, [
          'deviceId',
          'errorIds',
          'errors',
          'note',
          'reason',
          'serial',
          'imgErrors',
        ])
        const convertedData = {
          deviceErrorReq: deviceErrorReq,
          id: dataConvert.id,
          inventoryId: dataConvert.inventoryId,
          inventoryName: dataConvert.inventoryName,
          note: dataConvert.note,
          type: dataConvert.type,
        }
        return convertedData
      },
      preareDataAddWarranty() {
        const deviceErrorReq = omit(this.listDeviceError[0], [
          'typeError',
          'name',
          'edit',
          'abbreviation',
        ])
        console.log(deviceErrorReq)

        const inventoryName = this.warehouseUserActiveData.find(
          item => item.id === this.dataRequest.inventoryId
        )
        const dataPreare = {
          deviceErrorReq,
          idMposMerchant: this.dataRequest.idMposMerchant,
          emailMerchant: this.dataRequest.emailMerchant,
          inventoryId: this.dataRequest.inventoryId,
          inventoryName: this.dataRequest.id
            ? this.dataRequest.processingInventoryName
            : inventoryName.text,
          note: this.dataRequest.note,
          type: this.dataRequest.type,
        }
        return dataPreare
      },
      async fetchData() {
        const warrantyId = this.$route.params.id
        if (warrantyId) {
          try {
            this.showLoading = true
            const responsive = await DeviceService.detailWarranty(warrantyId)
            if (responsive.code === 1000) {
              this.fetchWarehouse()
              this.dataRequest = responsive.data
              this.dataRequest.inventoryId = responsive.data.processingInventoryId
              this.typeWarranty = responsive.data.type
              this.listDeviceError.push(responsive.data.deviceError)
              this.fetchDeviceActive(responsive.data.processingInventoryId)
              this.merchantSelected = responsive.data.mcInfo.data
              this.onSelectMerchant(responsive.data.mcInfo.data)
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
      async fetchWarehouse() {
        try {
          this.showLoading = true
          const response = await DeviceService.getListWarehouseUserActive()
          this.warehouseUserActiveData = response.data.map(
            ({ id, name, level, regions, cityCode }) => {
              return { id, text: name, level, regions, cityCode }
            }
          )
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchDeviceActive(id) {
        try {
          const data = {
            id: id,
            status: ['WARRANTY', 'AVAILABILITY', 'USED'],
          }
          this.showLoading = true
          const res = await DeviceService.getListDeviceActive(data)
          this.listDevice = res.data.map(({ id, nickname, serial, abbreviation, categoryName }) => {
            return { id, text: `${nickname} - ${serial}`, abbreviation, name: categoryName, serial }
          })
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async updateDevice(data) {
        if (data.edit === true) {
          const dataFindIndex = this.listDeviceError.findIndex(
            item => item.deviceId === data.deviceId
          )
          if (dataFindIndex !== -1) {
            const dataUpdate = { ...this.listDeviceError[dataFindIndex], ...data }
            delete dataUpdate.edit
            this.listDeviceError.splice(dataFindIndex, 1, dataUpdate)
          }
        } else {
          const dataDevice = this.preareDataAddedeice(data)
          const dataListDeviceError = { ...data, ...dataDevice }
          this.listDeviceError.push(dataListDeviceError)
        }
        this.$bvModal.hide('request-device-error')
        this.isShowModalRequestDevice = false
      },

      async closeModalRequestDevice() {
        this.$bvModal.hide('request-device-error')
        this.isShowModalRequestDevice = false
      },
      showModalRequestDevice() {
        const data = { edit: false }
        this.dataDevice = data
        this.isShowModalRequestDevice = true
        this.$nextTick(s => this.$bvModal.show('request-device-error'))
      },
      preareDataAddedeice(data) {
        const dataPreare = this.listDevice.find(item => item.id === data.deviceId)
        const dataDevice = {
          name: dataPreare.name,
          serial: dataPreare.serial,
        }
        return dataDevice
      },
      deleteDevice(index) {
        this.listDeviceError.splice(index, 1)
      },
      async editDevice(item) {
        const data = item
        data.edit = true
        this.dataDevice.fileUploads = data.imgErrors
        this.dataDevice = data
        this.isShowModalRequestDevice = true
        this.$nextTick(s => this.$bvModal.show('request-device-error'))
      },
      checkChange(newVal) {
        if (this.listDeviceError.length > 0) {
          this.listDeviceError[0].errorIds = []
          this.listDeviceError[0].errors = []
          this.listDeviceError[0].typeError = ''
          this.editDevice(this.listDeviceError[0])
          this.dataRequest.type = newVal
        } else {
          this.dataRequest.type = newVal
        }
      },
      checkChangeInventory(newVal) {
        if (this.listDeviceError.length > 0) {
          this.checkHandledInventory(newVal)
        } else {
          this.dataRequest.inventoryId = newVal
          this.fetchDeviceActive(newVal)
        }
      },
      onSelectMerchant(mc) {
        this.merchantSelected = mc
        this.dataRequest.idMposMerchant = mc.customerId
        this.dataRequest.emailMerchant = mc.email
      },
    },
  }
</script>

<style scoped>
  .addDevice {
    display: flex;
    justify-content: space-between;
  }
  .tableDevice {
    min-height: 145px;
  }
</style>
